import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Types } from './enums';
import { isType } from './utils/typeUtils';
import APPLICATION_CONSTANTS from './applicationConstants';

/**
 * Represents the internationalization wrapper for translations.
 */
class I18n {
  /**
   * Initializes the translations.
   * @param {Object} translation The translations.
   */
  static init(translation) {
    const resources = {};
    let specificTranslation = translation;
    const currentLanguage = APPLICATION_CONSTANTS.GLOBAL.CURRENT_LANGUAGE;

    if (isType(translation, Types.array)) {
      specificTranslation = translation.find(t => t.LanguageTag === currentLanguage);
      delete specificTranslation['LanguageTag'];
    }

    resources[currentLanguage] = {
      translation: specificTranslation
    };
    
    i18n
      .use(initReactI18next)
      .init({
        resources: resources,
        lng: currentLanguage,
        fallbackLng: ['en', 'en-us'],
        keySeparator: false,
        lowerCaseLng: true
      });
  }
}

export default I18n;
